import type { MouseEvent, FC, ReactNode } from 'react';
import React, { memo } from 'react';
import { Spin } from 'antd';
import classNames from 'classnames';
import styles from './Button.module.scss';

type ButtonProps = {
  content?: string;
  disabled?: boolean;
  onClick?: (ev: MouseEvent<HTMLButtonElement>) => void;
  type?: 'submit' | 'reset' | 'button' | undefined;
  contentClassName?: string;
  className?: string;
  isLoading?: boolean;
  cssType?: 'dark' | 'grey' | 'orange';
  icon?: ReactNode;
  value?: string;
  containerClassName?: string;
  testId?: string;
};
export const Button: FC<ButtonProps> = memo(
  ({
    disabled,
    type,
    content,
    onClick,
    className,
    contentClassName,
    icon,
    cssType,
    isLoading = false,
    value,
    containerClassName,
    testId,
  }) => {
    return (
      <div
        className={classNames(
          'w-full flex justify-end items-center',
          containerClassName,
        )}
      >
        <button
          disabled={disabled}
          onClick={onClick}
          data-testid={testId}
          data-value={value}
          className={classNames(
            styles.button,
            styles[cssType as keyof typeof styles],
            className,
            { 'opacity-40	': disabled },
          )}
          type={type}
        >
          {isLoading ? (
            <Spin spinning />
          ) : (
            <div
              className={classNames('flex items-center gap-3', {
                'pr-7': !!icon && !!content,
              })}
            >
              {icon && icon}
              {content && (
                <span className={classNames(contentClassName, '!font-barlow')}>
                  {content}
                </span>
              )}
            </div>
          )}
        </button>
      </div>
    );
  },
);
